import { render, staticRenderFns } from "./widget-contact-form.vue?vue&type=template&id=5b8bcda7&scoped=true&"
import script from "./widget-contact-form.ts?vue&type=script&lang=ts&"
export * from "./widget-contact-form.ts?vue&type=script&lang=ts&"
import style0 from "./widget-contact-form.scss?vue&type=style&index=0&id=5b8bcda7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b8bcda7",
  null
  
)

export default component.exports